import React from 'react';
import styles from './TopView.module.less';

interface TopViewProps {
  data: any;
  reverseSearchContent?: React.ReactNode;
}

/**
 * TopView 共用组件
 * reverseSearchContent: 可选的搜索框内容
 */
export default function TopView({ data, reverseSearchContent }: TopViewProps) {
  const title = data?.contentInfo?.['hero']?.title || '';
  const highlightText = data?.contentInfo?.['hero']?.highlight || '';
  const bodyText = data?.contentInfo?.['hero']?.bodyText || [];

  // 渲染标题，如果 highlightText 在 title 中匹配到则高亮显示
  const renderTitle = () => {
    if (!highlightText || !title.includes(highlightText)) {
      return title;
    }
    const index = title.indexOf(highlightText);
    const before = title.slice(0, index);
    const after = title.slice(index + highlightText.length);
    return (
      <>
        {before}
        <span className={styles.highlight}>{highlightText}</span>
        {after}
      </>
    );
  };

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        {/* 标题 */}
        <h1 className={styles.title}>{renderTitle()}</h1>

        {/* 描述 */}
        {bodyText.map((text: string, index: number) => (
          <p key={index} className={styles.description}>
            {text}
          </p>
        ))}
      </div>

      {/* 自定义搜索框内容 */}
      {reverseSearchContent && <div className={styles.reverseSearch}>{reverseSearchContent}</div>}
    </div>
  );
}
